import { getAllSurveys, initSurvey } from "actions/surveyAction";
import { get } from 'lodash';
import { connect } from 'react-redux';
import { setCurrentPath } from "reducers/NavmenuReducer";
import SurveyLandingPage from "views/SurveyLandingPage";

const mapStateToProps = ({ auth: { user }, survey: { gettingSurvey, survey, surveys } }) => {
  const userSurveys = get(user, 'status.surveys', []);

  return {
    userSurveys,
    survey,
    // The description is on the list payload, not the detail one.
    surveys,
    gettingSurvey,
  };
};

export default connect(mapStateToProps, { initSurvey, getAllSurveys, setCurrentPath })(SurveyLandingPage);
